import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const Pass: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path clipRule="evenodd" d="M2.5 6.25C2.5 4.86929 3.61929 3.75 5 3.75H15C16.3807 3.75 17.5 4.86929 17.5 6.25L2.5 6.25ZM2.5 7.5V13.75C2.5 15.1307 3.61929 16.25 5 16.25H15C16.3807 16.25 17.5 15.1307 17.5 13.75V7.5L2.5 7.5ZM11.25 11.25L9.375 12.3325V10.1675L11.25 11.25ZM5.625 12.3325L7.5 11.25L5.625 10.1675V12.3325ZM15 11.25L13.125 12.3325V10.1675L15 11.25Z" fillRule="evenodd" /> 
  </CustomIcon>
);

export default Pass;